

import GlobalStyles from "./styles/GlobalStyles";
import { light } from "./styles/Themes";
import { ThemeProvider } from "styled-components";
import { web3Modal } from './components/web3ModalConfig.js'; // Adjust the import path as necessary
import CustomScrollbar from "./components/CustomScrollBar.js";
import { lazy, Suspense } from "react";
import Loading from "./components/Loading";

// Below Imports using React.lazy and Suspence

const Navigation = lazy(() => import("./components/Navigation"));
const Home = lazy(() => import("./components/sections/Home"));
const About = lazy(() => import("./components/sections/About"));
const Roadmap = lazy(() => import("./components/sections/Roadmap"));
const Team = lazy(() => import("./components/sections/Team"));
const Showcase = lazy(() => import("./components/sections/Showcase"));
const Faq = lazy(() => import("./components/sections/Faq"));
const Footer = lazy(() => import("./components/Footer"));
const ScrollToTop = lazy(() => import("./components/ScrollToTop"));
const Presale = lazy(() => import("./components/sections/Presale"));
const Chart = lazy(() => import("./components/sections/Chart"));
const Mint = lazy(() => import("./components/sections/Mint.js"));
const TokenCreator = lazy(() => import("./components/sections/TokenCreator.js"));
const Explore = lazy(() => import("./components/sections/Explore.js"));
const Divider = lazy(() => import("./components/sections/Divider.js"));


function App() {
  return (

    <main>
        <web3Modal> {/* Wrap your components with Web3ModalProvider */}

      <GlobalStyles />
      <ThemeProvider theme={light}>
        <Suspense fallback={<Loading />}>
          <Navigation />
          
          <Home />
          <Divider title="About Us" />

          <About />
          <Divider/>

          <Explore /> 
          <Divider title="🐻 The Flarenstein Bears Mint 🐻" />

          <Mint />
          <Showcase />

          <Divider title=" Meme Token Creator " />
          <TokenCreator />
          <Roadmap />
          <Chart  />

          <Team />
          <Faq />
          
          <Footer />
          {/* <ScrollToTop scrollPosition={y}/> */}
          <ScrollToTop />{" "}
        </Suspense>
      </ThemeProvider>
      </web3Modal>

    </main>

  );
}

export default App;
